import React from "react";
import { useTheme } from "styled-components";

const UpcomingBirthdays = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.84 3.7a1.11 1.11 0 0 0-1.829.406l-3.69 10.152a1.113 1.113 0 0 0 1.037 1.492q.198-.001.384-.07l10.151-3.692a1.11 1.11 0 0 0 .406-1.828zm-.587 9.508-2.46-2.461.925-2.546 4.081 4.081zm-3.867 1.406.985-2.701 1.719 1.72zm7.583-2.757L6.142 7.032l.915-2.522 6.428 6.429zm.281-6.794c.01-.38.103-.754.27-1.096.373-.745 1.076-1.154 1.98-1.154.471 0 .773-.162.96-.507.098-.194.154-.406.165-.623a.563.563 0 0 1 1.125.004c0 .905-.6 2.25-2.25 2.25-.471 0-.773.162-.96.507a1.55 1.55 0 0 0-.165.623.563.563 0 0 1-1.125-.005m-1.688-2.25V1.125a.563.563 0 0 1 1.126 0v1.688a.563.563 0 0 1-1.126 0m7.149 5.789a.562.562 0 0 1-.796.795L14.79 8.272a.563.563 0 0 1 .796-.796zm.342-3.006-1.688.563a.563.563 0 0 1-.355-1.068l1.687-.562a.563.563 0 0 1 .356 1.067"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default UpcomingBirthdays;
